import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AuthAccessProvider } from '../core/core.auth';
import {
    UserContext, BaseComponent, Project, ProjectResponse, TaskType,
    TaskTypeResponse, FieldResponse, Field, CreateTaskResponse, Activity, UserInfo
} from '../core/core.component';
import { MessageProvider } from '../service/message.service';
import { TaskService } from '../service/task.service';
import { ActivityService } from '../service/activity.service';
import { BusyProvider } from '../service/busy.service';
import { SelectItem } from 'primeng/primeng';
import { UserService } from '../service/user.service';

declare var $: any;

@Component({
    selector: 'app-task-detail',
    templateUrl: './task-detail.component.html',
    styleUrls: ['./task-detail.component.css'],
    host: { '(window:keydown)': 'shortcutHandler($event)' }
})
export class TaskDetailComponent extends BaseComponent implements OnInit {
    static DIALOG_ID: string = "detailTaskDialog";
    title: string = "Crea Task";
    successMessage: string = null;
    errorMessage: string;
    loadingTaskType: boolean = false;
    loadingFields: boolean = false;
    showTimeIstruction: boolean = false;
    isOpendAsPlugin: boolean = false;
    @Output() completeAction = new EventEmitter<number>();

    project: Project[] = [];
    projectList: SelectItem[] = [];
    selectedProject: Project = null;
    taskTypeList: SelectItem[] = [];
    selectedTaskType: TaskType = null;
    taskTitle: string = null;
    customFields: Field[] = [];
    completed: boolean = true;

    userContext: UserContext = null;
    userInfo: UserInfo;
    currentUserId: string = null;

    constructor(protected authAccess: AuthAccessProvider,
        protected router: Router,
        protected messageProvider: MessageProvider,
        private taskService: TaskService,
        private activityService: ActivityService,
        private busyProvider: BusyProvider,
        private userService: UserService) {
        super(authAccess, router, messageProvider);
    }

    ngOnInit() {

        this.userContext = this.authAccess.getUserContext();

        if (this.userContext == null) {
            this.authAccess.invalidate();
        } else {
            this.userService.currentUserInfo(this.userContext.srmToken).subscribe(
                result => {
                    this.userInfo = result;
                },
                error => {
                    this.handleError(error);
                }
            );

            let projectResponse: ProjectResponse;
            this.projectList = [];
            this.project = [];
            this.taskService.getUserProjects(this.userContext.srmToken).subscribe(
                response => {
                    projectResponse = response;
                    this.project = projectResponse.userProjects;
                    this.projectList.push({ label: "Nessun Progetto", value: null });
                    this.selectedProject = this.projectList[0].value;
                    for (let i = 0; i < projectResponse.userProjects.length; ++i) {
                        let project: Project = projectResponse.userProjects[i];
                        this.projectList.push({ label: project.name, value: project });
                    }
                },
                error => {
                    this.setErrorMessage(this.retrieveError(error));
                }
            );

            $("#" + TaskDetailComponent.DIALOG_ID).on('shown.bs.modal', function () {
                $("#srmTaskTitle").focus();
            });

            this.taskService.getTaskDetailStatus().subscribe(
                status => {
                    if (status == "open" || status == "openAsPlugin") {
                        $("#" + TaskDetailComponent.DIALOG_ID).modal({ backdrop: 'static', keyboard: false });
                        this.successMessage = null;
                        this.errorMessage = null;
                        this.isOpendAsPlugin = status == "openAsPlugin";
                        this.initialize(true);
                    } else {
                        this.close();
                    }
                }
            );
        }
    }

    createTask(nextToActivity: boolean) {
        this.successMessage = null;
        this.errorMessage = null;
        if (this.taskTitle == null || this.taskTitle.trim() == "") {
            this.errorMessage = "Inserisci la descrizione di riepilogo del task";
            return;
        }
        if (this.selectedProject == null) {
            this.errorMessage = "Selezionare il progetto di riferimento";
            return;
        }
        if (this.selectedTaskType == null) {
            this.errorMessage = "Selezionare la tipologia del task";
            return;
        }

        for (let i = 0; i < this.customFields.length; ++i) {
            if (this.customFields[i].required && this.customFields[i].value == null) {
                this.errorMessage = "Il campo " + this.customFields[i].description + " è obbligatorio";
                return;
            }
            if (this.customFields[i].name == "percent_complete" && this.customFields[i].value != null) {
                let val = Number(this.customFields[i].value);
                if (isNaN(val) || val < 0 || val > 100) {
                    this.errorMessage = "Il campo " + this.customFields[i].description + " è errato: inserire un valore nel compreso tra 0 e 100";
                    return;
                }
            }
        }

        let res: CreateTaskResponse;
        this.busyProvider.showBusyIndicator();
        this.completed = false;
        this.taskService.createTask(this.userContext.srmToken, this.selectedProject.id,
            this.selectedTaskType.id, this.taskTitle, this.customFields)
            .subscribe(
                response => {
                    res = response;

                    // porto il task a "In Lavorazione"
                    this.taskService.changeTaskStatus(this.userContext.srmToken, res.issue.id, 'O').subscribe();
                    // non mi importa del risultato

                    let msg = "Creato Task <a href=" + res.issue.href + " target='_new'>" + res.issue.issueNo + "</a>";
                    this.busyProvider.hideBusyIndicator();
                    this.completed = true;
                    if (!nextToActivity) {
                        this.messageProvider.notifyMessage(msg);
                        this.close();
                    } else {
                        let activity: Activity = new Activity();
                        activity.issueId = res.issue.id;
                        activity.isForNewTask = true;
                        this.close();
                        this.activityService.openActivityDetail(activity);
                    }
                    this.completeAction.emit(res.issue.id);
                },
                error => {
                    this.busyProvider.hideBusyIndicator();
                    this.setErrorMessage(this.retrieveError(error));
                    this.completed = true;
                }
            );

    }

    retrieveTaskType() {
        this.errorMessage = null;
        if (this.selectedProject == null) {
            this.taskTypeList = [];
            this.selectedTaskType = null;
            this.initialize(true);
            return;
        }
        this.taskTypeList = [];
        this.selectedTaskType = null;
        this.customFields = [];
        let typesResponse: TaskTypeResponse;
        this.loadingTaskType = true;
        this.taskService.getTaskTypeForProject(this.userContext.srmToken, this.selectedProject.id).subscribe(
            response => {
                typesResponse = response;
                this.taskTypeList = [];
                this.selectedTaskType = null;
                for (let i = 0; i < typesResponse.projectIssueTypes.length; ++i) {
                    let _type: TaskType = typesResponse.projectIssueTypes[i];
                    this.taskTypeList.push({ label: _type.name, value: _type });
                }
                if (this.taskTypeList.length > 0) {
                    this.selectedTaskType = this.taskTypeList[0].value;
                    this.retrieveCustomFields();
                }
                this.loadingTaskType = false;
            },
            error => {
                this.loadingTaskType = false;
                this.handleError(error);
            }
        );
    }

    retrieveCustomFields() {
        if (this.selectedProject == null) {
            this.errorMessage = "Selezionare il progetto";
            return;
        }
        if (this.selectedTaskType == null) {
            this.errorMessage = "Selezionare la tipologia";
            return;
        }
        this.errorMessage = null;
        let fieldsResponse: FieldResponse;
        this.customFields = [];
        this.loadingFields = true;
        this.taskService.getCustomFields(this.userContext.srmToken, this.selectedProject.id, this.selectedTaskType.id).subscribe(
            response => {
                fieldsResponse = response;
                for (let i = 0; i < fieldsResponse.issueFields.length; ++i) {
                    let field: Field = fieldsResponse.issueFields[i];
                    field.options = [];
                    this.customFields.push(field);
                    if (field.values != null) {
                        Object.keys(field.values).forEach(function (key) {
                            var value = field.values[key];
                            field.options.push({ label: value, value: key });
                        });
                        if (field.name == 'clientecse') {
                            // ordinamento per descrizione (quindi ABI)
                            field.options.sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
                            if (this.selectedProject.name == "CSE") {
                                let index = field.options.findIndex(opzione =>
                                    opzione.label.startsWith("ABI 09999")
                                );
                                if (index !== -1) {
                                    let opzioneCliente = field.options[index];
                                    field.options.splice(index, 1);   
                                    field.options.unshift(opzioneCliente); 
                                }
                            } else {
	                            field.options.unshift({ label: "Non Specificato", value: "" });
							}
                            field.value = field.options[0].value;
                        } else if (field.name == 'ufficiodicompetenza' && this.userInfo.ufficioBodyRental) {
                            // prevalorizzo la combo con l'ufficio indicato in UserInfo                            
                            let opzioneUfficio = field.options.find(opzione => opzione.label.startsWith(this.userInfo.ufficioBodyRental + " "));
                            if (opzioneUfficio) {
                                field.value = opzioneUfficio.value;
                            }
                        }
                        if (field.name == 'ufficiodicompetenza') {
                            field.options = field.options.filter(
                                opzione => !opzione.label.startsWith("zz")
                            );
                            field.options.sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
                            field.options.unshift({ label: this.userInfo.ufficioBodyRental, value: this.userInfo.ufficioBodyRental });
                        }
                        if (field.name != 'clientecse' && field.name != 'ufficiodicompetenza') {
                            field.options.unshift({ label: "Non Specificato", value: "" });
                            field.value = field.options[0].value;
                        }
                    }
                    if (field.name == "percent_complete") {
                        field.placeholder = "0-100 %";
                    }
                    if (field.name == "estimated_time") {
                        field.placeholder = "Es. 4 hours oppure 1 day, 3 hours ... ";
                    }
                }
                this.loadingFields = false;
            },
            error => {
                this.handleError(error);
            }
        );
    }

    close() {
        $("#" + TaskDetailComponent.DIALOG_ID).modal("hide");
        this.errorMessage = null;
    }

    private initialize(reset: boolean) {
        if (reset) {
            this.taskTitle = null;
            this.taskTypeList = [];
            this.selectedTaskType = null;
            this.customFields = [];
            this.loadingFields = false;
            this.loadingTaskType = false;
            this.selectedProject = null;
            for (let i = 0; i < this.project.length; ++i) {
                let project: Project = this.project[i];
                if (this.userInfo.clienteBodyRental && project.key.toUpperCase() == this.userInfo.clienteBodyRental) {
                    this.selectedProject = project;
                    this.retrieveTaskType();
                    break;
                }
            }
        } else {
            this.retrieveCustomFields();
        }
    }

    private setErrorMessage(errMsg) {
        this.errorMessage = errMsg;
        this.successMessage = null;
    }

    private setSuccessMessage(successMsg) {
        this.successMessage = successMsg;
        this.errorMessage = null;
    }

    openTimeInstructions() {
        this.showTimeIstruction = true;
    }

    closeTimeInstructions() {
        this.showTimeIstruction = false;
    }

    shortcutHandler(event) {
        if (event.keyCode == 27) { // ESC
            this.close();
        }
    }



}



// WEBPACK FOOTER //
// ./src/app/task-detail/task-detail.component.ts